<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">Lock / Unlock</span>
      <v-scroll-x-transition>
        <div class="d-flex">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-autocomplete
            v-model="filterArea"
            :items="[
              { text: 'ไม่ระบุพื้นที่', area_code: 'no-area' },
              ...this.areas.map((area) => ({
                text: `${area.area_code} - ${area.title_th}`,
                ...area,
              })),
            ]"
            item-text="text"
            item-value="area_code"
            label="พื้นที่"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            style="width: 240px; background-color: white"
          ></v-autocomplete>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="lockUnlockData"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
      must-sort
    >
      <template v-slot:item.hardware.area.area_code="{ item }">
        <div v-if="item.hardware && item.hardware.area">
          <div>{{ item.hardware.area.area_code }}</div>
          <div class="caption grey--text text--darken-1">
            {{ item.hardware.area.title_th }}
          </div>
        </div>
        <div v-else class="grey--text text-darken-1">-</div>
      </template>
      <template v-slot:item.hardware.hardware_model_code="{ item }">
        <div>
          {{ item?.hardware?.hardware_model?.title || '-' }}
        </div>
      </template>
      <template v-slot:item.view="{ item }">
        <v-btn outlined color="primary" @click.stop="handleClickView(item)">
          ดูแผนภาพ
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogView" width="1280">
      <v-card>
        <v-card-title class="body-2 grey lighten-2 d-flex">
          <div class="flex-grow-1 d-flex">
            <div style="width: 280px">
              <div style="color: gray">รหัส Device :</div>
              <div class="body-2">
                {{ hardwareLockUnlockTableView.hardware_code }}
              </div>
            </div>
            <div>
              <div style="color: gray">คำอธิบาย Device</div>
              <div class="body-2">
                {{ hardwareLockUnlockTableView.title_th }}
              </div>
            </div>
          </div>
          <div>
            <v-btn icon @click="dialogView = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <v-tabs
            v-model="tabLockUnlockTableView"
            centered
            style="border-bottom: 1px solid #eeeeee"
          >
            <v-tab :disabled="uiCtrl && !uiCtrl.isEnable('tab:::lock:get')"
              >Lock</v-tab
            >
            <v-tab :disabled="uiCtrl && !uiCtrl.isEnable('tab:::unlock:get')"
              >Unlock</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tabLockUnlockTableView">
            <v-tab-item>
              <TimeTableView
                :timeTableData="hardwareLockUnlockTableView.lock_detail"
              />
            </v-tab-item>
            <v-tab-item>
              <TimeTableView
                :timeTableData="hardwareLockUnlockTableView.unlock_detail"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <LockUnlockForm
      :formShow="lockUnlockFormShow"
      :lockUnlock="lockUnlock"
      :lockUnlockInit="lockUnlockInit"
      @isLockUnlockDataChange="handleLockUnlockFormDataChange"
      @formActionCompleted="handleLockUnlockFormActionCompleted"
      @onReset="handleLockUnlockFormReset"
      @onChangeDayCopy="handleOnChangeDayCopy"
      @onDayCopyCancel="handleOnDayCopyCancel"
      @onDayCopy="handleOnDayCopy"
      @onSaveLockUnlock="handleOnSaveLockUnlock"
      @onCopyFrom="handleOnCopyFrom"
      @onCopyToSuccess="handleOnCopyToSuccess"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TimeTableView from '@/components/TimeTableView.vue'
import LockUnlockForm from '@/views/lock-unlock/LockUnlockForm.vue'

export default {
  components: {
    LockUnlockForm,
    ConfirmDialog,
    TimeTableView,
  },
  data() {
    return {
      dialogForbidden: false,
      filterArea: null,
      lockUnlockData: [],
      tabLockUnlockTableView: 'tabLockUnlockTableView',
      hardwareLockUnlockTableView: {
        hardware_code: '',
        title_th: '',
        lock_detail: [],
        unlock_detail: [],
      },
      sortBy: ['hardware.area.area_code'],
      sortDesc: [true],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      lockUnlockFormShow: false,
      lockUnlockInit: {
        hardware: {
          hardware_uuid: '',
          hardware_code: '',
          title_th: '',
          title_en: '',
        },
        lock_uuid: '',
        lock_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
        unlock_uuid: '',
        unlock_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
      },
      lockUnlock: {
        hardware: {
          hardware_uuid: '',
          hardware_code: '',
          title_th: '',
          title_en: '',
        },
        lock_uuid: '',
        lock_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
        unlock_uuid: '',
        unlock_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
      },
      isLockUnlockDataChange: false,
      timeout: null,
      dialogView: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        {
          text: 'พื้นที่',
          align: 'start',
          value: 'hardware.area.area_code',
          filter: (value) => {
            if (!this.filterArea) {
              return true
            }
            if (this.filterArea === 'no-area') {
              return !value
            }
            return value === this.filterArea
          },
        },
        {
          text: 'รหัส Device',
          align: 'start',
          value: 'hardware.hardware_code',
        },
        { text: 'คำอธิบาย Device', align: 'start', value: 'hardware.title_th' },
        {
          text: 'ชื่อรุ่น Device',
          align: 'start',
          value: 'hardware.hardware_model_code',
        },
        {
          text: 'Lock / Unlock',
          align: 'center',
          sortable: false,
          value: 'view',
        },
      ]
    },
    locks() {
      return this.$store.state.lockUnlock.locks
    },
    unlocks() {
      return this.$store.state.lockUnlock.unlocks
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'Lock / Unlock',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    this.loading = true

    Promise.all([
      this.fetchLocks({
        company_uuid,
        params: {
          dpc: 'lock-unlock-to-list-lock',
        },
      }),
      this.fetchUnlocks({
        company_uuid,
        params: { dpc: 'lock-unlock-to-list-unlock' },
      }),
      this.fetchAreas({
        company_uuid,
        params: { dpc: 'lock-unlock-to-list-area' },
      }),
    ])
      .then(() => {
        this.lockUnlockData = this.locks.map((lock) => {
          const unlock = this.unlocks.find(
            (unlock) =>
              unlock.hardware.hardware_uuid === lock.hardware.hardware_uuid
          )
          return {
            ...lock,
            unlock_detail: unlock ? [...unlock.unlock_detail] : [],
            unlock_uuid: unlock ? unlock.unlock_uuid : '',
          }
        })

        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchLocks: 'lockUnlock/fetchLocks',
      fetchLock: 'lockUnlock/fetchLock',
      fetchUnlocks: 'lockUnlock/fetchUnlocks',
      fetchUnlock: 'lockUnlock/fetchUnlock',
      fetchAreas: 'area/fetchAreas',
    }),
    handleOnCopyToSuccess() {
      const { company_uuid } = this.$store.state.authentication.company

      this.loading = true

      Promise.all([
        this.fetchLocks({ company_uuid, params: { dpc: 'lock-to-list-lock' } }),
        this.fetchUnlocks({
          company_uuid,
          params: { dpc: 'unlock-to-list-unlock' },
        }),
      ])
        .then(() => {
          this.lockUnlockData = this.locks.map((lock) => {
            const unlock = this.unlocks.find(
              (unlock) =>
                unlock.hardware.hardware_uuid === lock.hardware.hardware_uuid
            )
            return {
              ...lock,
              unlock_detail: unlock ? [...unlock.unlock_detail] : [],
              unlock_uuid: unlock ? unlock.unlock_uuid : '',
            }
          })

          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleOnCopyFrom(item) {
      this.lockUnlock = JSON.parse(JSON.stringify(item))
    },
    handleClickView(lockUnlockSelected) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('tab:::lock:get') &&
        this.uiCtrl &&
        !this.uiCtrl.isEnable('tab:::unlock:get')
      ) {
        this.dialogForbidden = true
        return
      }

      this.dialogView = true
      this.hardwareLockUnlockTableView = {
        hardware_code: lockUnlockSelected.hardware?.hardware_code,
        title_th: lockUnlockSelected.hardware?.title_th,
        lock_detail: lockUnlockSelected.lock_detail.map((lock) => {
          return {
            time_period: lock.lock_time_period.map((item) => {
              if (item.time_period_start && item.time_period_end) {
                return {
                  time_period_start: item.time_period_start,
                  time_period_end: item.time_period_end,
                  start:
                    Number(item.time_period_start.split(':')[0]) * 44 +
                    (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                  end:
                    (Number(item.time_period_end.split(':')[0]) -
                      Number(item.time_period_start.split(':')[0])) *
                      44 +
                    Number(item.time_period_end.split(':')[1] / 60) * 44 -
                    Number(item.time_period_start.split(':')[1] / 60) * 44,
                }
              }
            }),
          }
        }),
        unlock_detail: lockUnlockSelected.unlock_detail.map((unlock) => {
          return {
            time_period: unlock.unlock_time_period.map((item) => {
              if (item.time_period_start && item.time_period_end) {
                return {
                  time_period_start: item.time_period_start,
                  time_period_end: item.time_period_end,
                  start:
                    Number(item.time_period_start.split(':')[0]) * 44 +
                    (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                  end:
                    (Number(item.time_period_end.split(':')[0]) -
                      Number(item.time_period_start.split(':')[0])) *
                      44 +
                    Number(item.time_period_end.split(':')[1] / 60) * 44 -
                    Number(item.time_period_start.split(':')[1] / 60) * 44,
                }
              }
            }),
          }
        }),
      }
    },
    handleOnSaveLockUnlock({ hardware_uuid, lock_detail, unlock_detail }) {
      this.lockUnlockData = this.lockUnlockData.map((lockUnlock) => {
        if (lockUnlock.hardware.hardware_uuid === hardware_uuid) {
          return {
            ...lockUnlock,
            lock_detail: [...lock_detail],
            unlock_detail: [...unlock_detail],
          }
        }
        return {
          ...lockUnlock,
        }
      })
    },
    handleOnChangeDayCopy(lockUnlock) {
      this.lockUnlock = JSON.parse(JSON.stringify(lockUnlock))
    },
    handleOnDayCopyCancel(lockUnlock) {
      this.lockUnlock = JSON.parse(JSON.stringify(lockUnlock))
    },
    handleOnDayCopy(lockUnlock) {
      this.lockUnlock = JSON.parse(JSON.stringify(lockUnlock))
    },
    classRowSelected(row) {
      if (
        this.lockUnlockData.hardware?.hardware_uuid ===
        row.hardware?.hardware_uuid
      ) {
        return 'row-selected'
      }
    },
    async setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('tab:::lock:get') &&
        this.uiCtrl &&
        !this.uiCtrl.isEnable('tab:::unlock:get')
      ) {
        this.dialogForbidden = true
        return
      }

      try {
        if (this.uiCtrl && this.uiCtrl.isEnable('tab:::lock:get')) {
          await this.fetchLock({
            company_uuid: this.$store.state.authentication.company.company_uuid,
            hardware_uuid: row.hardware?.hardware_uuid,
          })
        } else if (this.uiCtrl && this.uiCtrl.isEnable('tab:::unlock:get')) {
          await this.fetchUnlock({
            company_uuid: this.$store.state.authentication.company.company_uuid,
            hardware_uuid: row.hardware?.hardware_uuid,
          })
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (
        this.lockUnlockData.hardware?.hardware_uuid ===
        row.hardware?.hardware_uuid
      ) {
        this.lockUnlockFormShow = false
        this.lockUnlock = JSON.parse(JSON.stringify(this.lockUnlockInit))
        this.lockUnlockInit = JSON.parse(JSON.stringify(this.lockUnlockInit))
      } else {
        this.lockUnlockFormShow = true
        this.lockUnlock = JSON.parse(JSON.stringify(row))
        this.lockUnlockInit = JSON.parse(JSON.stringify(row))
      }
    },
    handleRowSelected(row) {
      if (this.isLockUnlockDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleLockUnlockFormDataChange(value) {
      this.isLockUnlockDataChange = value
    },
    handleLockUnlockFormReset() {
      this.lockUnlock = JSON.parse(JSON.stringify(this.lockUnlockInit))
      this.lockUnlockInit = JSON.parse(JSON.stringify(this.lockUnlockInit))
    },
    handleLockUnlockFormActionCompleted() {
      this.lockUnlock = JSON.parse(JSON.stringify(this.lockUnlockInit))
      this.lockUnlockInit = JSON.parse(JSON.stringify(this.lockUnlockInit))
      this.lockUnlockFormShow = false
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.lockUnlockFormShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isLockUnlockDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style>
.btn-text {
  color: #2196f3;
}
.btn-text:hover {
  text-decoration: underline;
}
</style>
